import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { setupGlobalErrorLogging } from "./lib/system-logger";
import { initSentry } from "./lib/sentry";
import { initClarity } from "./lib/clarity";

// Inicializa monitoramento global do Sentry
initSentry();

// Inicializa gravações de sessão e mapas de calor (Microsoft Clarity)
initClarity();

// Inicia o rastreamento automático de exceções JS e promessas não tratadas (banco interno)
setupGlobalErrorLogging();

const buildInfo: TickethallBuildInfo =
  typeof __TICKETHALL_BUILD__ !== "undefined"
    ? __TICKETHALL_BUILD__
    : {
        commit: "dev",
        branch: "local",
        builtAt: new Date().toISOString(),
        builtAtBrt: "agora (dev)",
      };

// Expõe pra inspecionar no console: window.__TICKETHALL_BUILD__
window.__TICKETHALL_BUILD__ = buildInfo;

// Banner bem visível no DevTools
// eslint-disable-next-line no-console
console.log(
  `%c TicketHall %c ${buildInfo.commit} %c ${buildInfo.builtAtBrt} `,
  "background:#ea580b;color:#fff;font-weight:700;padding:2px 6px;border-radius:3px 0 0 3px",
  "background:#111;color:#fff;padding:2px 6px",
  "background:#333;color:#fbbf24;padding:2px 6px;border-radius:0 3px 3px 0",
);
// eslint-disable-next-line no-console
console.log("[TicketHall build]", buildInfo);

// Desativa duplo toque para dar zoom em telas touch (preservando interação de formulários e botões)
if (typeof window !== "undefined") {
  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (event) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        const target = event.target as HTMLElement | null;
        if (
          target &&
          !["INPUT", "TEXTAREA", "SELECT", "OPTION"].includes(target.tagName) &&
          !target.isContentEditable
        ) {
          event.preventDefault();
        }
      }
      lastTouchEnd = now;
    },
    { passive: false }
  );
}

createRoot(document.getElementById("root")!).render(<App />);
